module.exports = __webpack_public_path__ + "static/media/bree-lesb.3b697a0f.jpg";